import React, { useEffect, useState } from "react";


import message from 'antd/lib/message';
import Popconfirm from 'antd/lib/popconfirm';
import Spin from 'antd/lib/spin';
import Pagination from 'antd/lib/pagination';
import { Table } from 'antd/lib/table';
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import AppService from './../../../../service/app_service'
import AuthenticationService from './../../../../service/authentication_service'
import UrlService from './../../../../service/url_service'
import TopBarComponent from './../../component/topbar_component'
import ModalComponent from './../../component/modal_component'
import SockJsClient from 'react-stomp';


//import "./../../pro_assets/css/protected.css";


var interval = null;
var downloadTimer = null;
const GiveawayPage = () => {

    const [loading, setLoading] = useState(false);
    const [transactions, setTransactions] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [pageNumber, setPageNumber] = useState(1);
    const [totalTransactionCount, setTotalTransactionCount] = useState(0);

    const [showGiveawayModal, setShowGiveawayModal] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [paymentSuccessful, setPaymentSuccessful] = useState(false);
    const [account, setAccount] = useState(null);
    const [amount, setAmount] = useState(0);
    const [giveawayAmount, setGiveawayAmount] = useState(0);
    const [giveawayQuantity, setGiveawayQuantity] = useState(0);
    const [giveawayUseDice, setGiveawayUseDice] = useState(0);
    const [giveawayDuration, setGiveawayDuration] = useState(0);
    const [giveawayRewardType, setGiveawayRewardType] = useState('airtime');
    const [giveawayGameType, setGiveawayGameType] = useState('fastestFinger');
    const [giveawayRewardPosition, setGiveawayRewardPosition] = useState('highest');
    
    const [giveaways, setGiveaways] = useState([]);
    const [clientRef, setClientRef] = useState(null);
    const [orderRef, setOrderRef] = useState((new Date()).getTime().toString());

    const [channel, setChannel] = useState(null);
    const [email, setEmail] = useState(AuthenticationService.getEmail());
    const [name, setName] = useState(AuthenticationService.getName());
    const [phone, setPhone] = useState(AuthenticationService.getMobileNumber());
    const [publicKey, setPublicKey] = useState('pk_test_2372fc72b7cb8c49bab910c839370a2bbbc855b4');
    const [paystackAmount, setPaystackAmount] = useState(9000);
    

    const [totalAmount, setTotalAmount] = useState(null);
    

    useEffect(() => {
        setChannel(channelGenerator());
        getTransactions(pageNumber);
        //eslint-disable-next-line
        
    }, []);

    const getTransactions = async (pageNumber) => {
        setLoading(true);
        AppService.getGiveawayOrders(pageSize, pageNumber).then(rec => {
            setLoading(false)
            if (rec.error) {
                // AuthenticationService.clearLocalstorage();
                // this.props.history.push('/');
            } else {
                setLoading(false);
                setTransactions(rec.list)
                if(rec &&  rec.list){
                    //setTotalTransactionCount(rec.list.length);
                }
            }
        })
    }

    const changePage= (val) =>{
        setPageNumber(val)
        getTransactions(val);
    }

    const paymentConfirmationCron = (ref) => {
        // navigator.serviceWorker.ready.then(registration => {
        //     interval = setInterval(() => {
        //         paymentConfirmation(false, ref);
        //         //registration.showNotification(title, options)
        //     }, 10000)
        // })
        interval = setInterval(() => {
            paymentConfirmation(false, ref);
        }, 10000)
    }

    const paymentConfirmation = (alerter, ref) => {
        setLoading(alerter);
        console.log("ref:",ref)
        let data = {};
        data.order = {};
        data.order.orderRef = ref;
        AppService.paymentConfirmation(data).then(rec => {

            setLoading(false);
            if (!rec.code) {
                if (rec.action === 'SUCCESS') {
                    message.success(rec.message);
                    //call back for order to be checked out
                    clearInterval(interval);
                    clearInterval(downloadTimer);
                    var element = document.getElementById("countdown");
                    if (element)
                        element.innerHTML = rec.message;

                    setShowModal(false);
                    setChannel(channelGenerator());
                    getTransactions(pageNumber);
                }
            } else {
                if(rec.description == 'Transaction has expired'){
                    clearInterval(interval);
                    clearInterval(downloadTimer);
                    var element = document.getElementById("countdown");
                    if (element)
                        element.innerHTML = rec.message;

                    message.error(rec.description);
                    setShowModal(false);
                }
                else if (alerter){
                    message.error(rec.description)
                }
                    
            }

        })

    }

    const payWithAccount = (ref) => {
        setLoading(true);
        let data = {};
        data.order = {};
        data.order.orderRef = ref;
        AppService.payWithAccount(data).then(rec => {
            setLoading(false);
            if (!rec.code) {
                if (rec.action === 'SUCCESS') {
                    message.success(rec.message);
                    setShowModal(false);
                    setChannel(channelGenerator());
                    getTransactions(pageNumber);
                }
            } else {
                message.error(rec.description);
            }

        })

    }

    const startCounter = (timeleft) => {
        downloadTimer = setInterval(function () {
            if (timeleft <= 4) {
                clearInterval(downloadTimer);
                if (document.getElementById("countdown") != null)
                    document.getElementById("countdown").innerHTML = "Time is up";
            } else {
                var minutes = Math.floor(timeleft / 60);
                var seconds = timeleft - (minutes * 60);
                var left = minutes + ":" + seconds;
                var element = document.getElementById("countdown");
                if (element)
                    element.innerHTML = left;

            }
            timeleft -= 1;
        }, 1000);
    }
    
    const makePayment = (debitMyAccount) => {
        //giveaway:qty_amount,qty_amount,qty_amount
        let arr = giveaways.map(item => (item.amount+'_'+ item.quantity+'_'+ item.gameType+'_'+ item.duration+'_'+ item.rewardType+'_'+ item.rewardPosition));
        let codedMessage = "giveaway:"+ arr.toString();
        console.log(codedMessage);
        let data = {};
        data.xo = AuthenticationService.getToken();
        data.emailAddress = AuthenticationService.getEmail();
        data.channel = channel;
        data.amount = amount;
        data.codedMessage = codedMessage;
        data.debitMyAccount = debitMyAccount;
        data.message = "GIVEAWAY";
        console.log("data:", data);
        clientRef.sendMessage('/app/make/payment', JSON.stringify(data));
        setLoading(true);
    };
    const config = {
        reference: orderRef,
        email: email,
        amount: paystackAmount,
        publicKey: publicKey,
        metadata: {
            name: name,
            phone: phone,
        }
    };


    const setAmountState = (amount) => {
        setAmount(amount);
        setPaystackAmount(100 * (amount + (200 + (1.5 * amount/100))));
    }

    const handleChange = (e) => {
        if(e.target.name === 'giveawayAmount'){
            setGiveawayAmount(e.target.value);
        }else if(e.target.name === 'giveawayQuantity'){
            setGiveawayQuantity(e.target.value);
        }else if(e.target.name === 'giveawayUseDice'){
            setGiveawayUseDice(e.target.value);
        }else if(e.target.name === 'giveawayDuration'){
            setGiveawayDuration(e.target.value);
        }else if(e.target.name === 'giveawayGameType'){
            setGiveawayGameType(e.target.value);
        }else if(e.target.name === 'giveawayRewardType'){
            setGiveawayRewardType(e.target.value);
        }else if(e.target.name === 'giveawayRewardPosition'){
            setGiveawayRewardPosition(e.target.value);
        }
        

    }

    const addMoreGiveaway = () => {
        if(giveawayQuantity > 0 && giveawayAmount > 0){

            if("dice" === giveawayGameType &&  giveawayDuration < 1){
                alert("Missing dice game duration.")
            }else {
                let data = {};
                data.id =  channelGenerator();
                data.quantity = giveawayQuantity;
                data.amount = giveawayRewardType === 'cash' ? (parseInt(giveawayAmount) + 20) : parseInt(giveawayAmount);
                data.useDice = 0;
                data.duration = giveawayDuration;
                data.gameType = giveawayGameType;
                data.rewardType = giveawayRewardType;
                data.rewardPosition = giveawayRewardPosition;
                // data.useDice = giveawayUseDice;
                giveaways.push(data);
                
                setGiveawayAmount(0);
                setGiveawayQuantity(0);
                // setGiveawayUseDice(0);
                setGiveawayDuration(0);
                calculateTotal(giveaways);
            }
            
        }else {
            alert("Missing quantity or amount.");
        }
        
    };

    const removeGiveaway = (id) => {
        let result = giveaways.filter(function( obj ) {
            return obj.id !== id;
        });
        setGiveaways(result);
        calculateTotal(result);
    };

    const calculateTotal = (giveaways) => {
        let amt = giveaways.length > 0 ?giveaways.map(item => (item.amount * item.quantity)).reduce((prev, next) => prev + next) : 0;
        setAmountState(amt);
    }

    const channelGenerator = () => {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
            return v.toString(16);
        });
    }

    const formatAmount = (amount) => {
        return amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    }

    const closePaymentModal = () => {
        setShowModal(!showModal);
        clearInterval(interval);
        clearInterval(downloadTimer);
    }


    return (
        <div id="main-wrapper" className="admin-dashboard-demos" style={{ background: '#e0e8f3',minHeight: '700px' }} >
            <TopBarComponent />
            <div className="page-content">
                <div className="container">
                    <div className="card content-area">
                        <div className="card-innr">
                            <div className="card-head" style={{width: '100%'}}>
                                <h4 className="card-title">My Giveaways  <em className="text-primary ti ti-reload" style={{paddingLeft: '15px'}}  onClick={() => getTransactions(pageNumber)} /></h4>
                                <div   style={{float: 'right', margin: '10px 0px', width: '100%'}}>
                                    <a className="btn btn-sm btn-outline btn-light" onClick={() => setShowGiveawayModal(true)} style={{float: 'right'}}><em className="text-primary ti ti-files" /><span>Generate Giveaway</span></a>
                                </div>
                            </div>

                            <div className="content-area card"  style={{width: '100%'}}>
                                <div className="card-innr">
                                    <div className="card-head">
                                        <h4 className="card-title">What is giveaway?</h4>
                                    </div>
                                    <p>
                                    Giveaway is an act or instance of giving something away and with this platform, 
                                    you can do a giveaway directly to the benefactors via airtime and any network of their choice,
                                    or via bank transfer to their bank account directly.
                                    </p>
                                    <Link to={"/giveaway/detail/ALL"}><span className={"tnx-type-md badge badge-outline badge-success badge-md"} >View ALL</span><span className="tnx-type-sm badge badge-sq badge-outline badge-success badge-md">View</span></Link>
                                </div>
                            </div>

                            <div id="DataTables_Table_0_wrapper" className="dataTables_wrapper dt-bootstrap4 no-footer" style={{paddingTop: '10px', marginTop: '40px'}}>
                                <div className="table-wrap">
                                
                                <Spin spinning={loading}>
                                <table className="data-table dt-init user-tnx dataTable no-footer" id="DataTables_Table_0" role="grid" aria-describedby="DataTables_Table_0_info">
                                        <thead>
                                            <tr className="data-item data-head" role="row">
                                                <th className="data-col dt-tnxno sorting_disabled" rowSpan={1} colSpan={1}>Order</th>
                                                <th className="data-col dt-token sorting_disabled" rowSpan={1} colSpan={1}>Amount</th>
                                                <th className="data-col dt-usd-amount sorting_disabled" rowSpan={1} colSpan={1}>Created By</th>
                                                <th className="data-col dt-account sorting_disabled" rowSpan={1} colSpan={1}>Giveaway</th>
                                                <th className="data-col dt-type sorting_disabled" rowSpan={1} colSpan={1}>
                                                    <div className="dt-type-text">View</div>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            { transactions && transactions.length > 0 && transactions.map((item, i) => {
                                                let codedMessageItem = item.codedMessage.split(":");
                                                let codedMessageInfoList = codedMessageItem[1].split(",");
                                                let amountPerGiveaway = "";
                                                let noInGiveaway = "";
                                                codedMessageInfoList.map((msg, ii) => {
                                                    let codedMessageInfo = msg.split("_");
                                                    
                                                    if((codedMessageInfo[0] > 0)) {
                                                        amountPerGiveaway = amountPerGiveaway + parseFloat(codedMessageInfo[0]).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') + ", ";
                                                        noInGiveaway = noInGiveaway + codedMessageInfo[1] + ", ";
                                                    }
                                                    
                                                })
                                                let codedMessageInfo = codedMessageItem[1].split("_");
                                                    return<tr className="data-item odd" role="row" key={i}>
                                                <td className="data-col dt-tnxno">
                                                    <div className="d-flex align-items-center">
                                                        <div className={"data-state "+(item.status === "PAID" ? 'data-state-approved' : (item.status === "EXPIRED" ? 'data-state-canceled' : 'data-state-progress'))}><span className="d-none">{item.status}</span></div>
                                                        <div className="fake-class"><span className="lead tnx-id">{item.orderRef}</span><span className="sub sub-date">{item.createdAt}</span></div>
                                                    </div>
                                                </td>
                                                <td className="data-col dt-token"><span className="lead token-amount">&#8358; {parseFloat(item.totalAmount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}</span><span className="sub sub-symbol">{item.status}</span></td>
                                                
                                                <td className="data-col dt-usd-amount"><span className="lead amount-pay">{item.createdBy}</span></td>
                                                <td className="data-col dt-account"><span className="lead user-info">&#8358; {amountPerGiveaway} per giveaway</span><span className="sub sub-date">{noInGiveaway} giveaways</span></td>
                                                <td className="tnx-type"><Link to={"/giveaway/detail/"+item.orderRef}><span className={"" +(item.status === "PAID" ? 'tnx-type-md badge badge-outline badge-success badge-md' : (item.status === "EXPIRED" ? 'tnx-type-md badge badge-outline badge-danger badge-md' : 'tnx-type-md badge badge-outline badge-warning badge-md'))}  >View</span><span className="tnx-type-sm badge badge-sq badge-outline badge-success badge-md">View</span></Link> </td>
                                                
                                            </tr> }) }

                                            {transactions && transactions.length > 0 && <tr>
                                                <Pagination onChange={changePage} pageSize={pageSize} defaultCurrent={pageNumber} current={pageNumber} total={totalTransactionCount} />
                                            </tr>}
                                        </tbody>
                                    </table>
                                </Spin>
                                </div>
                            </div>
                        </div>
                        {/* .card-innr */}
                    </div>
                    {/* .card */}
                </div>
                {/* .container */}
            </div>

            {showModal && <ModalComponent show={showModal} closeModal={() => closePaymentModal()} title="Make payment" >
                    <Spin spinning={loading}>
                    <div>

                        {!paymentSuccessful && <div>
                            <p>Please make a bank transfer to the account detail below.</p>
                            <div className="gaps-1x" />
                            {/* <h6 className="font-bold">Payment to the following bank detail</h6> */}
                            <div className="row">
                                <div className="col-sm-4">
                                    <h6 style={{paddingTop: '20px'}}>Account Number</h6>
                                </div>
                                <div className="col-sm-8">
                                    <div className="copy-wrap mgb-0-5x" style={{fontSize: '20px', fontWeight: 400}}>
                                        <span className="copy-feedback" style={{ display: 'none' }}>Copied to Clipboard</span>
                                        <em className="fab fa-account" />
                                        <input type="text" className="copy-address" style={{padding: '12px 30px 12px 20px'}} defaultValue={account && account.accountNumber} disabled />
                                        <button onClick={() => { navigator.clipboard.writeText(account && account.accountNumber); message.info(' Copied to Clipboard') }} className="copy-trigger copy-clipboard" data-clipboard-text={account && account.accountNumber}><em className="ti ti-files" /></button>
                                    </div>
                                </div>
                            </div>
                            
                            {/* .copy-wrap */}
                            <ul className="pay-info-list row">
                                <li className="col-sm-12" style={{fontSize: '15px', fontWeight: 400}}><span>Bank:</span> <strong>{account && account.bank}</strong></li>
                                <li className="col-sm-12" style={{fontSize: '15px', fontWeight: 400}}><span>Account Name:</span> <strong>{account && account.accountName}</strong></li>
                                <li className="col-sm-12" style={{fontSize: '15px', fontWeight: 400}}><span>Amount:</span> <strong style={{fontSize: '18px'}}>&#8358; {account && account.totalAmount && account.totalAmount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}</strong></li>
                            </ul>
                            
                            <div style={{fontSize: '16px', color: 'red'}}>You have to make payment in the next <h5 id="countdown"></h5></div>
                            
                            <div className="note note-plane note-light mgb-1x" style={{fontSize: '16px'}}>
                                <em className="fas fa-info-circle" />
                                <p>Do not make payment to another account.  </p>
                            </div>
                            <div className="note note-plane note-danger" style={{fontSize: '16px'}}>
                                <em className="fas fa-info-circle" />
                                <p>Send the exact amount stated above. Nothing more, nothing less</p>
                            </div>
                            <div className="note note-plane note-light" style={{fontSize: '16px', marginTop: '10px'}}>
                                <em className="fas fa-info-circle" />
                                <p><strong>For any payment or giveaway issues, call or send whatsapp to +2348060765123 for immediate support.</strong> </p>
                            </div>
                            <div className="note note-plane note-danger" style={{fontSize: '16px', marginTop: '10px'}}>
                                <em className="fas fa-info-circle" />
                                <p>You can also pay with your funded account by clicking on <strong> Pay With My Account</strong></p>
                            </div>
                            <div className="gaps-3x" />
                            <button className="btn btn-primary" style={{float: 'right'}} onClick={() => paymentConfirmation(true, orderRef)} >Confirm Payment  <em className="ti ti-arrow-right mgl-4-5x" /></button>
                            
                            <button className="btn btn-success" style={{float: 'right', marginRight: '8px'}} onClick={() => payWithAccount(orderRef)} >Pay With My Account<em className="ti ti-arrow-right mgl-4-5x" /></button>


                            
                            
                        </div>}

                        {paymentSuccessful && <div className="status status-thank px-md-5">
                            <div className="status-icon"><em className="ti ti-check" /></div>
                            <span className="status-text large text-dark">Thank you for submitting form</span>
                            <p className="px-md-5">We received your data, our team will check and get back you via email.</p>
                        </div>}
                    </div>
                    </Spin>
                </ModalComponent>}

                {showGiveawayModal && <ModalComponent show={setShowGiveawayModal} closeModal={() => setShowGiveawayModal(false)} title="Add Giveaway" >
                    <div >
                        <Spin spinning={loading}>
                            <div className="row scroll-modal" style={{overflow: 'scroll',overflowY: 'scroll',maxHeight: '500px'}}>
                                <div className="col-md-6">
                                    <div className="input-item input-with-label">
                                        <label className="input-item-label">Amount Per Giveaway</label>
                                        <input type="number" name="giveawayAmount" value={giveawayAmount} className="input-bordered" placeholder="Amount Per Giveaway" onChange={handleChange} />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="input-item input-with-label">
                                        <label className="input-item-label">How many giveaway</label>
                                        <input type="number" name="giveawayQuantity" value={giveawayQuantity} className="input-bordered" placeholder="How many giveaway" onChange={handleChange} />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="input-item input-with-label">
                                        <label htmlFor="nationality" className="input-item-label">Giveaway Game Type</label>
                                        <select className="input-bordered" name="giveawayGameType" id="giveawayGameType" onChange={handleChange} >
                                            <option value="fastestFinger">Fastest Finger</option>
                                            <option value="dice">Roll Dice</option>
                                            <option value="wordSearch">Word Search Game</option>
                                            <option value="numberGame">Number Puzzle Game</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="input-item input-with-label">
                                        <label htmlFor="nationality" className="input-item-label">Giveaway Reward Channel</label>
                                        <select className="input-bordered" name="giveawayRewardType" id="giveawayRewardType" onChange={handleChange} >
                                            <option value="airtime">Airtime</option>
                                            <option value="cash">Cash</option>
                                        </select>
                                    </div>
                                </div>
                                {giveawayGameType === 'dice' && <div className="col-md-6">
                                    <div className="input-item input-with-label">
                                        <label className="input-item-label">Dice Game duration (minutes)</label>
                                        <input type="number" name="giveawayDuration" value={giveawayDuration} className="input-bordered" placeholder="Dice Game duration" onChange={handleChange} />
                                    </div>
                                </div>}
                                {giveawayGameType === 'dice' &&  <div className="col-md-6">
                                    <div className="input-item input-with-label">
                                        <label htmlFor="nationality" className="input-item-label">Giveaway Reward Position</label>
                                        <select className="input-bordered" name="giveawayRewardPosition" id="giveawayRewardPosition" onChange={handleChange} >
                                            <option value="highest">Highest</option>
                                            <option value="lowest">Lowest</option>
                                        </select>
                                    </div>
                                </div>}
                                <div className="col-md-12">
                                    <button className="btn btn-primary" style={{float: 'right'}} onClick={() => addMoreGiveaway()} >Add</button>
                                </div>
                                <div className="col-md-12" style={{marginTop: '5px'}}>
                                    {giveawayRewardType === 'airtime' &&<h6 className="kyc-alert text-danger">* Note that each airtime reward giveaway requires no additional fees</h6>}
                                    {giveawayRewardType === 'cash' &&<h6 className="kyc-alert text-danger">* Note that each cash reward giveaway requires additional &#8358; 20.00 for each bank transfer to beneficiaries</h6>}
                                    
                                </div>

                                <div className="col-md-12" style={{marginTop: '10px'}}>
                                    <div className="row">
                                        { giveaways && giveaways.length > 0 && giveaways.map((item, i) => {
                                            let hint = "";
                                            if(item.rewardType === 'airtime'){
                                                hint = hint + "Note : participants will be rewarded with airtime.";
                                            }else {
                                                hint = hint + "Note : participants will be rewarded with cash.";
                                            }

                                            if(item.gameType === 'fastestFinger'){
                                                hint = hint + "And the giveaway will be won by beneficiary with fastest finger.";
                                            }else {
                                                hint = hint + "And the giveaway will be won by beneficiary with first "+item.rewardPosition+" dice value.";
                                            }
                                            return <div className="col-md-6" key={i} style={{boxShadow: 'rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px', paddingRight: '5px'}} >
                                                <div className="kyc-info card">
                                                    <div className="card-innr">
                                                        <div className="-">Amount Per Giveaway : <strong>&#8358; {formatAmount(item.amount)}</strong> </div>
                                                        <div className="">No of Giveaway           : <strong>{item.quantity}</strong> </div>
                                                        <div className="">Game Type              : <strong>{item.gameType}</strong> </div>
                                                        <div className="">Reward Channel       : <strong>{item.rewardType}</strong> </div>
                                                        <div className="">Reward Position       : <strong>{item.rewardPosition}</strong> </div>
                                                        <div className="">Amount       : <strong>&#8358; {formatAmount(item.amount * item.quantity)}</strong> </div>
                                                        <div className="">Delete       : <i className="fas fa-trash" onClick={() => removeGiveaway(item.id)} /></div>
                                                        <h6 className="kyc-alert text-danger">* {hint}</h6>
                                                    </div>
                                                </div>
                                            </div>
                                        })}
                                    </div>
                                </div>
                                <div className="col-md-12" style={{marginTop: '10px'}}>
                                    <h5>Giveaway Amount : {formatAmount(amount)}</h5>
                                </div>

                                <hr />
                                <br />
                                <br />
                                <br />
                                

                                {giveaways && giveaways.length > 0 && <div className="col-md-12">
                                <h6>Pay by bank transfer : Fee = &#8358; 100</h6>
                                    <h6>If you Pay by bank transfer,  Amount + Fee = &#8358; {formatAmount(100 + amount)}</h6>
                                    {<Popconfirm
                                        title="Are you sure to submit this transaction?"
                                        onConfirm={() => makePayment(false)}
                                        okText="Yes"
                                        cancelText="No"
                                    >
                                        <button type="submit" style={{float: 'right', marginRight: '8px'}} disabled={loading} name="submit" className="btn btn-success">Bank Transfer (&#8358; {formatAmount(100 + amount)})</button>
                                    </Popconfirm>}
                                    {<Popconfirm
                                        title="Are you sure to submit this transaction?"
                                        onConfirm={() => makePayment(true)}
                                        okText="Yes"
                                        cancelText="No"
                                    >
                                        <button type="submit" disabled={loading} name="submit" className="btn btn-success">Debit My Account (&#8358; {formatAmount(amount)})</button>
                                    </Popconfirm>}
                                </div>}
                                
                                {/* {giveaways && giveaways.length > 0 && <div className="col-md-6">
                                    <h6>Pay with card : Fee = &#8358; {formatAmount(200 + (1.5*amount/100))}</h6>
                                    <h6>Amount + Fee = &#8358; {formatAmount((200 + (1.5*amount/100)) + amount)}</h6>
                                    {<PaystackButton {...componentProps} className="btn btn-success btn-block" />}
                                </div>} */}

                            </div>
                        </Spin>




                    </div>
                </ModalComponent>}

                {<SockJsClient url={UrlService.BASE_PATH + '/unified/'}
                    topics={['/queue/chat/' + channel]}
                    onConnect={() => {
                        console.log("connected");
                        let data = {};
                        data.channel = channel;
                    }}
                    onDisconnect={() => {
                        console.log("Disconnected");
                    }}
                    onMessage={(msg) => {
                        console.log("mssg", msg)
                        if (msg.action === "MAKE_PAYMENT") {
                            setShowGiveawayModal(false);
                            setAccount(msg.account);
                            setAmountState(msg.order.totalAmount);
                            setOrderRef(msg.order.orderRef);
                            setShowModal(true);
                            setLoading(false);
                            startCounter(msg.timeFrame * 60);
                            paymentConfirmationCron(msg.order.orderRef);
                        }else if (msg.action === 'SUCCESS') {
                            message.success(msg.message);
                            setShowGiveawayModal(false);
                            setLoading(false);
                            getTransactions(pageNumber);
                        } else if (msg.action === "ERROR") {
                            setShowGiveawayModal(false);
                            setLoading(false);
                            message.error(msg.message);
                            getTransactions(pageNumber);
                        }
                    }}
                    ref={(client) => {
                        setClientRef(client);
                    }} />}



        </div>
    );

}

export default withRouter(GiveawayPage);
